<template>
  <inline-edit
    :action="route('settings.admission-chances')"
    title="Update admission chances"
    v-bind="{ user }"
  >
    <template v-if="$slots.default" #activator="{ activator }">
      <slot v-bind="{ activator }"/>
    </template>

    <div class="grid gap-5">
      <p class="leading-relaxed">
        Your admission chances reflect how likely you are to get admitted into each school
        based on your LSAT, GPA, and demographics.
      </p>

      <l-lsat-input v-model="user.lsat"/>

      <l-gpa-input v-model="user.gpa"/>

      <l-race-input v-model="user.race"/>
    </div>
  </inline-edit>
</template>

<script setup>
import InlineEdit from "@/components/inlines/InlineEdit.vue"
import LGpaInput from "@/components/inputs/LGpaInput.vue"
import LLsatInput from "@/components/inputs/LLsatInput.vue"
import LRaceInput from "@/components/inputs/LRaceInput.vue"
import route from "ziggy-js"

const user = defineModel({ type: Object })
</script>
